module.exports = __webpack_public_path__ + "img/暂无图片.935d2312.png";